import PropTypes from 'prop-types';
import './CopyIconCellRenderer.scss';

const CopyIconCellRenderer = ({ value }) => {
  const handleCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    await navigator.clipboard.writeText(value || '');
  };

  return (
    <div
      className="copy-icon-cell"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className="copy-icon btn-light nav-text-icon me-3"
        onClick={handleCopy}
        title="Copy Device ID"
      >
        <i className="far fa-lg fa-copy col-1"></i>
      </button>
    </div>
  );
};

CopyIconCellRenderer.propTypes = {
  value: PropTypes.string,
};

export default CopyIconCellRenderer;
